import { AddRounded, AutoAwesomeRounded, PersonRounded } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import { grey, yellow } from "@mui/material/colors";
import {
	attrConditionalDisplayColObj,
	attrGroupLinkedTables,
	attrGrpTableStrColumnsObj,
	colorImagesAssocObj,
	productionStageOptions,
	productPagePath,
	styleFileAssocObj,
	styleImagesAssocObj,
} from "components/PimDashboard/data";
import { AuthState } from "context/AuthContext";
import { PimDashboardState } from "context/PimDashboardContext";
import { inputTypes, statusOptions } from "data/globalData";
import { attrGrpAttrAssocObj } from "../DesignerAttributes/data";
import { useMemo, useState } from "react";
import axios from "axios";
import RenderAttributeInputs from "./RenderAttributes/RenderAttributeInputs";
import ImageSlider from "components/PimDashboard/CommonComponents/ImageSlider/ImageSlider";
import ColorsSection from "./ColorsSection/ColorsSection";
import AddNewImageModal, { isMainImg } from "./AddImagesModal/AddImagesModal";
import { getColDefaultValue } from "components/PimDashboard/data";
import { GlobalState } from "context/GlobalContext";
import { departments } from "data/authData";
import { useNavigate } from "react-router-dom";
import { styleFileColumns, styleFileUrlKey, styleImgDepartmentCol, styleUrlKey } from "./data";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import AddFiles, { fileColumn } from "components/PimDashboard/CommonComponents/AddFiles/AddFiles";
import { validateMandatoryFields } from "utils/mandatoryFieldsLogic";
import RenderConditionalAttributeInputs from "./RenderConditionalAttributes/RenderConditionalAttributeInputs";
import SuggestAttributesModal from "./SuggestAttributesModal/SuggestAttributesModal";
const imgWidth = 200;
const imgHeight = 240;
const CreateStyle = () => {
	const { user } = AuthState();
	const { attrGroupsWithAttr, setAttrGroupsWithAttr, allAttributes, setSelectedStyle } = PimDashboardState();
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();

	const navigate = useNavigate();

	const [newStyleDetails, setNewStyleDetails] = useState(() => {
		let obj = {};
		allAttributes.forEach((attr) => {
			if (!obj[attr?.linked_table]) obj[attr?.linked_table] = {};
			obj[attr?.linked_table][attr?.key] = getColDefaultValue(attr);
		});
		return obj;
	});
	const [pageFiles, setPageFiles] = useState([]);
	const [errobj, setErrorObj] = useState({});
	const [images, setImages] = useState([]);
	const [colors, setColors] = useState([]);
	const [imgModalOpen, setImgModalOpen] = useState(false);
	const [suggestModalOpen, setSuggestModalOpen] = useState(false);
	const handleAddImageClick = () => {
		setImgModalOpen(true);
	};
	const handleSaveImgClick = (Images) => {
		setImages([...Images]);
		return true;
	};
	const handleFileUpload = async (styleImages, colors, pageFiles) => {
		// append formdata with multiple file and its name

		const uploadStyleColorImgs = async () => {
			const formData = new FormData();
			styleImages?.forEach((image) => {
				formData.append("styleImages", image.file);
			});
			colors?.forEach((image) => {
				formData.append("colorImages", image.file);
			});
			const res = await axios.post("/api/designer/upload_style_col_images", formData, {
				headers: {
					"content-type": "multipart/form-data",
				},
			});

			return [res.data.styleImageUrls, res.data.colorImageUrls];
		};
		const uploadStyleFiles = async () => {
			if (pageFiles?.length) {
				const fileFormData = new FormData();

				pageFiles?.forEach((fileData) => {
					fileFormData.append("files", fileData[fileColumn.key]);
					fileFormData.append("fileMeta", JSON.stringify(fileData)); // corresponding metadata
				});
				const res = await axios.post("/api/upload/multiple_upload_to_rel_bucket", fileFormData, {
					headers: {
						"content-type": "multipart/form-data",
					},
				});
				return res.data.result;
			}
			return new Promise((resolve, reject) => {
				resolve([]);
			});
		};
		const [styleColorImgs, uploadedFiles] = await Promise.all([uploadStyleColorImgs(), uploadStyleFiles()]);

		return [...styleColorImgs, uploadedFiles];
	};

	const handleFormSubmit = async () => {
		setLoadingOpen(true);
		if (images.length === 0) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Add atleast one image",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}
		if (colors.length === 0) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Add atleast one color",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}
		const brand = newStyleDetails[attrGroupLinkedTables.style.key]?.brand || "";
		const category = newStyleDetails[attrGroupLinkedTables.style.key]?.department || "";

		const styleAttrs = allAttributes.filter(
			(row) => row?.linked_table === attrGroupLinkedTables.style.key && row?.input_type !== inputTypes.AUTO_GENERATE.key,
		);

		const validation = validateMandatoryFields(newStyleDetails, styleAttrs, brand, category, attrGroupLinkedTables.style.key);

		const pendingFields = validation.missingFields;

		if (pendingFields?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Enter values for ${pendingFields.map((row) => row?.name)}`,
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}

		const sysData = {
			last_updated_by: user?.email,
			created_by: user?.email,
			stage: productionStageOptions.STYLE_ATTRIBUTES.key,
			status: statusOptions.DESIGNER_PENDING.key,
		};

		try {
			let [styleImages, colorImages, uploadedFiles] = await handleFileUpload(images, colors, pageFiles);

			// finding main Img Url
			images.forEach((row, i) => {
				if (row[isMainImg] === true) {
					styleImages[i][isMainImg] = true;
					styleImages[i]["url"] = styleImages[i]["publicUrl"];
				}
			});
			colorImages = colorImages.map((row) => {
				return { url: row.publicUrl };
			});
			uploadedFiles = uploadedFiles.map((row) => {
				let dup = { ...row };
				delete dup["id"];
				return dup;
			});

			const colorsArr = [];
			colors.forEach((colorData, i) => {
				let obj = {};
				// filtering unnecessay object keys
				allAttributes
					.filter((row) => row?.linked_table === attrGroupLinkedTables.color.key)
					.forEach((attr) => {
						obj[attr.key] = colorData[attr.key];
					});
				colorsArr.push({ ...obj, ...sysData });
			});

			const body = newStyleDetails;
			// for joining color & images

			body[attrGroupLinkedTables.color.key] = colorsArr;
			// for joining style & images
			body[attrGroupLinkedTables.style.key] = {
				...body[[attrGroupLinkedTables.style.key]],
				...sysData,
				[styleImagesAssocObj]: styleImages,
				[styleFileAssocObj]: uploadedFiles,
			};
			body[colorImagesAssocObj] = colorImages;

			const res = await axios.post("/api/designer/create_style", body);
			setSelectedStyle();
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Style created successfully",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			navigate(`/${productPagePath}?${styleUrlKey}=${res.data.style_id}`);
			setLoadingOpen(false);
		} catch (error) {
			setLoadingOpen(false);
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, message: parseErrorMessage(error) });
		}
	};

	const handleDesignerFileAdd = async (newFileData) => {
		setPageFiles((prev) => [...prev, { ...newFileData, [styleFileUrlKey]: "To be Uploaded" }]);

		return true;
	};

	async function handleDesignerFileDelete(fileData) {
		setPageFiles((prev) => prev.filter((row) => row?.id !== fileData?.id));

		return true;
	}

	const styleAttrs = useMemo(
		() =>
			allAttributes.filter(
				(row) => row?.linked_table === attrGroupLinkedTables.style.key && row?.input_type !== inputTypes.AUTO_GENERATE.key,
			),
		[allAttributes],
	);

	const brand = newStyleDetails[attrGroupLinkedTables.style.key]?.brand || "";
	const category = newStyleDetails[attrGroupLinkedTables.style.key]?.department || "";
	const styleMainDetailsValidation = validateMandatoryFields(
		newStyleDetails,
		styleAttrs,
		brand,
		category,
		attrGroupLinkedTables.style.key,
	);
	const mainImage = images.find((row) => row?.[isMainImg]) || images?.[0];
	const canSuggestAttributes = Boolean(mainImage?.file) && styleMainDetailsValidation.missingFields.length === 0;
	const suggestAttributesHelperText = !mainImage?.file
		? "Select a main image first to get suggested attributes."
		: styleMainDetailsValidation.missingFields.length > 0
			? `Fill main details first: ${styleMainDetailsValidation.missingFields.map((row) => row?.name).join(", ")}`
			: "";
	const mainDetailsGroup = useMemo(
		() => Object.values(attrGroupsWithAttr).filter((row) => row?.is_main === true),
		[attrGroupsWithAttr],
	);
	const sortedDetailsGroups = useMemo(
		() =>
			Object.entries(attrGroupsWithAttr)
				.reduce((acc, [groupKey, group]) => {
					if (attrGroupsWithAttr[groupKey]?.is_main === true) return acc;

					if (groupKey === "fabric_details") {
						// acc.push({
						// 	...group,
						// 	groupKey,
						// 	[attrGrpAttrAssocObj]: group[attrGrpAttrAssocObj].map((row) => ({
						// 		...row,
						// 		input_type: inputTypes.AUTO_GENERATE.key,
						// 	})),
						// });
					} else acc.push({ ...group, groupKey });

					return acc;
				}, [])
				.sort((a, b) => a.sort_no - b.sort_no),
		[attrGroupsWithAttr],
	);

	return (
		<Box
			sx={{
				width: "100%",
				minHeight: "100%",
				bgcolor: "#f6f7fb",
				py: { xs: 1.5, md: 2.5 },
				boxSizing: " border-box",
				borderRadius: 1,
			}}>
			<Box
				sx={{
					width: "100%",
					maxWidth: 1700,
					mx: "auto",
					px: { xs: 1.25, sm: 2, md: 3 },
					boxSizing: " border-box",
				}}>
				<Box
					sx={{
						display: "grid",
						gridTemplateColumns: { xs: "1fr", xl: "320px 1fr" },
						gap: 2,
						alignItems: "start",
					}}>
					<Box
						sx={{
							p: { xs: 2, md: 2.5 },
							borderRadius: 3,
							border: `1px solid ${grey[200]}`,
							bgcolor: "#fff",
							boxShadow: "0 10px 28px rgba(15,23,42,0.05)",
						}}>
						<Box display="flex" width="100%" pb={1} justifyContent="space-between">
							<Typography variant="h6">Images</Typography>
							{images?.length > 0 && (
								<Button
									sx={{ textTransform: "capitalize" }}
									onClick={handleAddImageClick}
									size="small"
									startIcon={<AddRounded />}
									variant="outlined">
									Add / Set Main Images
								</Button>
							)}
						</Box>
						<Box
							width={imgWidth}
							height={imgHeight}
							sx={{ border: `1px solid ${grey[200]}` }}
							display="flex"
							alignItems="center"
							justifyContent="center">
							{images.length === 0 ? (
								<Box>
									<Button size="large" startIcon={<AddRounded />} onClick={handleAddImageClick}>
										Add Images
									</Button>
								</Box>
							) : (
								<Box width={imgWidth} height={imgHeight} display="flex" flexWrap="wrap" rowGap={2}>
									<ImageSlider imgWidth={imgWidth} imgHeight={imgHeight} column="url" images={images} />
								</Box>
							)}
							{/* */}
						</Box>
					</Box>

					<Box
						sx={{
							p: { xs: 2, md: 2.5 },
							borderRadius: 3,
							border: `1px solid ${grey[200]}`,
							bgcolor: "#fff",
							boxShadow: "0 10px 28px rgba(15,23,42,0.05)",
						}}>
						{mainDetailsGroup?.map((row) => {
							return (
								<Box key={row.groupKey} width="100%" pt={2} sx={{ "&:first-of-type": { pt: 0 } }}>
									<Typography variant="h6" sx={{ fontSize: 17, fontWeight: 700, mb: 1 }}>
										{row[attrGrpTableStrColumnsObj.name.key]}
									</Typography>
									{row?.data?.[attrConditionalDisplayColObj.key] ? (
										<RenderConditionalAttributeInputs
											columns={[...row[attrGrpAttrAssocObj]]}
											setData={setNewStyleDetails}
											data={newStyleDetails}
											attrGrp={row}
											errObj={errobj}
											setErrorObj={setErrorObj}
											itemWidth="24%"
										/>
									) : (
										<RenderAttributeInputs
											columns={[...row[attrGrpAttrAssocObj]]}
											setData={setNewStyleDetails}
											data={newStyleDetails}
											attrGrp={row}
											errObj={errobj}
											setErrorObj={setErrorObj}
											itemWidth="24%"
										/>
									)}
									<Box mt={2} display="flex" flexDirection="column" alignItems="flex-start">
										<Button
											onClick={() => setSuggestModalOpen(true)}
											variant="contained"
											startIcon={<AutoAwesomeRounded />}
											disabled={!canSuggestAttributes}
											sx={{
												textTransform: "none",
												fontWeight: 700,
												borderRadius: 999,
												px: 2,
												py: 1,
												background: "linear-gradient(90deg, #2563eb 0%, #3b82f6 100%)",
												color: "#eff6ff",
												boxShadow: "0 10px 24px rgba(37,99,235,0.22)",
												"&:hover": {
													background: "linear-gradient(90deg, #1d4ed8 0%, #2563eb 100%)",
												},
											}}>
											Suggest Attributes
										</Button>
										{suggestAttributesHelperText && (
											<Typography variant="caption" color="error" display="block" pt={1.25}>
												{suggestAttributesHelperText}
											</Typography>
										)}
									</Box>
								</Box>
							);
						})}
					</Box>
				</Box>

				<Box
					sx={{
						mt: 2,
						p: { xs: 2, md: 2.5 },
						borderRadius: 3,
						border: `1px solid ${grey[200]}`,
						bgcolor: "#fff",
						boxShadow: "0 10px 28px rgba(15,23,42,0.05)",
					}}>
					{sortedDetailsGroups?.map((row) => {
						if (row[attrGrpTableStrColumnsObj.linked_table.key] === attrGroupLinkedTables.color.key)
							return (
								<ColorsSection key={row.groupKey} colors={colors} setColors={setColors} styleData={newStyleDetails} />
							);

						return (
							<Box key={row.groupKey} width="100%" pt={1}>
								<Typography variant="h6" sx={{ fontSize: 17, fontWeight: 700, mb: 1 }}>
									{row[attrGrpTableStrColumnsObj.name.key]}
								</Typography>
								{row?.data?.[attrConditionalDisplayColObj.key] ? (
									<RenderConditionalAttributeInputs
										columns={[...row[attrGrpAttrAssocObj]]}
										setData={setNewStyleDetails}
										data={newStyleDetails}
										attrGrp={row}
										errObj={errobj}
										setErrorObj={setErrorObj}
										itemWidth="19%"
									/>
								) : (
									<RenderAttributeInputs
										columns={[...row[attrGrpAttrAssocObj]]}
										setData={setNewStyleDetails}
										data={newStyleDetails}
										attrGrp={row}
										errObj={errobj}
										setErrorObj={setErrorObj}
										itemWidth="19%"
									/>
								)}
							</Box>
						);
					})}
				</Box>

				<Box
					sx={{
						mt: 2,
						p: { xs: 2, md: 2.5 },
						borderRadius: 3,
						border: `1px solid ${grey[200]}`,
						bgcolor: "#fff",
						boxShadow: "0 10px 28px rgba(15,23,42,0.05)",
					}}>
					<AddFiles
						addNewDefault={{ [styleImgDepartmentCol.key]: departments.DESIGNER.key }}
						columns={styleFileColumns}
						handleAddFile={handleDesignerFileAdd}
						files={pageFiles}
						setFiles={setPageFiles}
						handleDelete={handleDesignerFileDelete}
					/>
				</Box>

				<Box sx={{ display: "flex", justifyContent: "center", pt: 2.5, pb: 1 }}>
					<Button
						onClick={handleFormSubmit}
						variant="contained"
						size="large"
						sx={{
							minWidth: 220,
							borderRadius: 999,
							textTransform: "none",
							fontWeight: 700,
							px: 3,
							py: 1.3,
							boxShadow: "0 12px 28px rgba(17,24,39,0.16)",
						}}>
						Create Style
					</Button>
				</Box>
			</Box>

			{/* add Images Modal */}
			{imgModalOpen && (
				<AddNewImageModal
					modalOpen={imgModalOpen}
					setModalOpen={setImgModalOpen}
					submitFunction={handleSaveImgClick}
					defaultImages={images}
				/>
			)}
			{suggestModalOpen && (
				<SuggestAttributesModal
					open={suggestModalOpen}
					onClose={() => setSuggestModalOpen(false)}
					baseData={newStyleDetails}
					setBaseData={setNewStyleDetails}
					mainImageFile={mainImage?.file}
				/>
			)}
		</Box>
	);
};

export default CreateStyle;
